import React from "react";
import { Link } from "react-router-dom";

function ServicesHero() {
  return (
    <div
      id="khalif-breadcrumb-wrap"
      className="khalif-breadcrumb-wrap breadcrumb-bg text-center d-flex align-items-center avatar"
      style={{ backgroundImage: `url('/assets/img/Development2.jpg')` }}
    >
      <div className="container">
        <div className="row">
          <div className="offset-xl-2 col-xl-8">
            <div className="khalif-breadcrumb-content">
              <h2> AI-Integration</h2>
              <ul className="breadcrumb justify-content-center">
                <li className="breadcrumb-item">
                  <Link to="/" title="Home">
                    Home /
                  </Link>
                </li>
                <li className="breadcrumb-item active"> AI-Integration</li>
              </ul>
              <p>
                We prioritize crafting applications with a
                strong emphasis on delivering an exceptional user experience and
                intuitive user interface. As we also manage the marketing
                aspect, we possess a deep understanding of what users expect in
                terms of content and the overall user experience.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ServicesHero;
